<script>
    import { defaultErrorMsg, defaultErrorMsgPrompt } from "../../Utils/utilConstants.svelte";
    import {
        ErrorDetail,
        ShowErrorModal,
        ErrorModalCloseFunction,
    } from "../../stores";

    let previousKeyDown = null;

    $: if ($ShowErrorModal) {
        previousKeyDown = document.onkeydown;
        enableCloseWithESC();
    }

    const enableCloseWithESC = () => {
        document.onkeydown = (event) => {
            if (event.key === "Escape") {
                closeModal();
            }
        };
    };

    const closeModal = () => {
        $ShowErrorModal = false;
        document.onkeydown = previousKeyDown ?? null;
        if ($ErrorModalCloseFunction) $ErrorModalCloseFunction();
    };
</script>

<div class={$ShowErrorModal ? "modal modal-open sm:modal-middle z-max" : "modal"}>
    <div class="modal-box w-1/3 max-w-full p-0">
        <h3 class="font-medium text-lg text-[#fff] flex-0 bg-[#8a3ed7] px-6 py-3">Oops...</h3>
        <div class="p-6">
            <p class="leading-6 text-error whitespace-pre-line">
                {defaultErrorMsg}
            </p>
            <p class="leading-6 text-error whitespace-pre-line">
                {$ErrorDetail ?? defaultErrorMsgPrompt}
            </p>
        </div>

        <div class="modal-action flex-1 justify-end gap-x-6 px-6 my-4">
            <button
                class="w-32 btn btn-error text-white text-[14px] rounded-xl"
                on:click={closeModal}
            >
                Close
            </button>
        </div>
    </div>
</div>